export default "__VITE_ASSET__CZcQKQps__"